var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-card-text',[_c('h3',[_vm._v("Pick image :")]),_c('ImagesCarusel',_vm._b({attrs:{"chunkArray":_vm.chunkImagesArray},on:{"selected":_vm.onClickHandler}},'ImagesCarusel',_vm.caruselProps,false))],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }